import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-display-pdf-dialog',
  templateUrl: './display-pdf-dialog.component.html',
  styleUrl: './display-pdf-dialog.component.scss',
})
export class DisplayPdfDialogComponent implements OnInit {
  pdfSrc: SafeResourceUrl = '';
  constructor(
    public dialogRef: MatDialogRef<DisplayPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.data?.src) {
      this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.src);
    }
  }
}
